// extracted by mini-css-extract-plugin
export default {"container":"ForfaitCard_container__AZoRa","title":"ForfaitCard_title__ZDaWn","discount":"ForfaitCard_discount__lvRaK"};